import {
    createStyles,
    Grid,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import { formatAuctionDateTime } from "../../../helpers/auctionDateTime";

type AuditTimestampsProps = WithStyles<typeof styles> & {
    createdBy?: string;
    createdOn?: string;
    modifiedBy?: string;
    modifiedOn?: string;
};
const WhiteTextTypography = withStyles({
    root: {
        color: "#FFFFFF"
    }
})(Typography) as typeof Typography;

const styles = () =>
    createStyles({
        auditDetail: { fontWeight: "bold" }
    });

function AuditTimestamps(props: AuditTimestampsProps) {
    const classes = props.classes;

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={6}>
                <WhiteTextTypography variant="caption" display="block">
                    Created By:{" "}
                    <span className={classes.auditDetail}>
                        {props.createdBy}
                    </span>
                </WhiteTextTypography>
                <WhiteTextTypography variant="caption" display="block">
                    Created On:&nbsp;
                    <span className={classes.auditDetail}>
                        {formatAuctionDateTime(props.createdOn)
                            ?.mediumDateTime ?? ""}
                    </span>
                </WhiteTextTypography>
            </Grid>
            <Grid item={true} xs={6}>
                <WhiteTextTypography variant="caption" display="block">
                    Modified By:{" "}
                    <span className={classes.auditDetail}>
                        {props.modifiedBy}
                    </span>
                </WhiteTextTypography>
                <WhiteTextTypography variant="caption" display="block">
                    Modified On:&nbsp;
                    <span className={classes.auditDetail}>
                        {formatAuctionDateTime(props.modifiedOn)
                            ?.mediumDateTime ?? ""}
                    </span>
                </WhiteTextTypography>
            </Grid>
        </Grid>
    );
}

export default withStyles(styles)(AuditTimestamps);
